import type { IdentityApiSdk } from "@packsize/identity-api-sdk";

import { type ExternalAccessType } from "@/schemas/external-access";
import { type ExternalAccessSubscription } from "@/views/configuration/server-settings/types";

export type CreateExternalAccessSubscriptionParams = {
	displayName: string;
	type: ExternalAccessType;
	selectedProducts: string[];
};

export type DeleteExternalAccessSubscriptionParams =
	| {
			subscriptionId: string;
			type: "apiKey";
	  }
	| {
			externalAccessId: string;
			type: "oauth";
	  };

export const externalAccessSubscriptionKey = ["external-access-subscriptions"];

export const getExternalAccessSubscriptions = async (client: IdentityApiSdk): Promise<ExternalAccessSubscription[]> => {
	const response = await client.getExternalAccessMeta("All");
	return (response.responseData as ExternalAccessSubscription[]) ?? [];
};

export const createExternalAccessSubscription = async (
	client: IdentityApiSdk,
	params: CreateExternalAccessSubscriptionParams,
) => {
	if (params.type === "apiKey") {
		return await client.createApimSubscription({
			displayName: params.displayName,
			selectedProducts: params.selectedProducts,
		});
	}

	if (params.type === "oauth") {
		return await client.createOAuthConnection({
			displayName: params.displayName,
			scopes: params.selectedProducts,
		});
	}

	throw new Error(`Subscription type ${params.type} not yet implemented`);
};

export const deleteExternalAccessSubscription = async (
	client: IdentityApiSdk,
	params: DeleteExternalAccessSubscriptionParams,
) => {
	if (params.type === "apiKey") {
		return await client.removeApimSubscription(params.subscriptionId);
	}

	return await client.deleteOAuthConnection(params.externalAccessId);
};
